const isMobileScreen = () => {
  if (typeof window !== "undefined") {
    return window.innerWidth <= 1199 ? true : false;
  }
};

const accordionHandler = (e) => {
  const { target } = e;
  const clickedAccordionList = target.closest(".accordion-list");
  if (!clickedAccordionList) return;

  const allAccordionLists = document.querySelectorAll(".accordion-list");

  if (!clickedAccordionList.classList.contains("is-open")) {
    // Close all other accordion-list elements
    allAccordionLists.forEach((list) => {
      list.classList.remove("is-open");
    });
    // Open the clicked accordion-list
    clickedAccordionList.classList.add("is-open");
  } else {
    // If clicked accordion-list is already open, close it
    clickedAccordionList.classList.remove("is-open");
  }
};

import dynamic from "next/dynamic";

const loadDynamicIcon = (iconName) => {
  if (typeof iconName !== "string" || iconName.trim().length === 0) {
    throw new Error("Invalid icon name");
  }

  return dynamic(
    () =>
      import("@/components/atoms/Icons").then((mod) => {
        const IconComponent = mod[iconName];
        if (!IconComponent) {
          throw new Error(`Unknown icon name: ${iconName}`);
        }
        return IconComponent;
      }),
    { fallback: () => <span>Loading...</span> }
  );
};

export { isMobileScreen, accordionHandler, loadDynamicIcon };
